import { FetchServiceContract } from '@/core/contracts';
import { IFirstStageData, ISecondStageData } from '@/dto/operationalPlanSummary/index';
import { ContextsState, ProductsState } from '@/store';
import { SiteGroup, HeaderData, DataCategory } from '.';
import { OperationalDay } from './OperationalDay';
import { OperationalDayName } from './OperationalDayName';
import { encodeParams } from '@/core/helpers';

export class ComponentData {

    public isFirstStageLoaded: boolean = false;
    public isSecondStageLoaded: boolean = false;
    public selectedDataCategory: DataCategory = DataCategory.IncomeMtr;
    public operDays: OperationalDay[] = [];
    public siteGroups: SiteGroup[] = [];
    public headerData: HeaderData;
    public filter: any = {};

    constructor() {
        this.headerData = new HeaderData(this);
    }

    public get currentProduct() {
        return ProductsState.current;
    }

    public async load(fetchService: FetchServiceContract): Promise<void> {
        this.isFirstStageLoaded = false;
        this.isSecondStageLoaded = false;

        const contextId = ContextsState.currentContextId;

        const urlFirstStage = `/ops/${contextId}/first?${encodeParams(
            this.filter
        )}`;
        const taskFirstStage = fetchService.get<IFirstStageData>(urlFirstStage)
            .then(data => {
                this.parseFirstStageData(data);
            })
            .finally(() => this.isFirstStageLoaded = true);

        const urlSecondStage = `/ops/${contextId}/second?${encodeParams(
            this.filter
        )}`;
        const taskSecondStage = fetchService.get<ISecondStageData>(urlSecondStage);

        Promise.all([taskFirstStage, taskSecondStage])
            .then(x => {
                this.parseSecondStageData(x[1]);
            })
            .finally(() => this.isSecondStageLoaded = true);
    }

    public selectCategory(category: DataCategory): void {
        this.selectedDataCategory = category;
    }

    private parseFirstStageData(data: IFirstStageData): void {
        if (!data) { throw new Error('data is not set'); }
        if (!data.siteGroups) { throw new Error('data.siteGroups is not set'); }

        const operDays = data.operDays;
        if (operDays) {
            this.operDays = operDays
                .map(x => OperationalDay.fromDto(x))
                .sort((l, r) => OperationalDayName.compare(l.name, r.name))
            ;
        }

        this.siteGroups.splice(0);
        for (const part of data.siteGroups) {
            const siteGroup = SiteGroup.fromFirstPart(part, this);
            this.siteGroups.push(siteGroup);
        }
    }

    private parseSecondStageData(data: ISecondStageData): void {
        if (!data) { throw new Error('data is not set'); }
        if (!data.siteGroups) { throw new Error('data.siteGroups is not set'); }

        for (const remoteSiteGroup of data.siteGroups) {

            const siteGroup = this.siteGroups.find(x => x.alias === remoteSiteGroup.alias);
            if (siteGroup) {
                siteGroup.parseSecondStageData(remoteSiteGroup);
            }

        }
    }
}
